// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"92":"css/app.6743","7654":"css/admin-app.6743"}[chunkId] + ".css";
};